import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Monitor, Wrench, AlertTriangle, Activity } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Total Aset IT", value: stats?.total_aset, icon: Monitor, testid: "stat-total-aset", color: "text-primary" },
    { label: "Sedang Dalam Perbaikan", value: stats?.dalam_perbaikan, icon: Wrench, testid: "stat-dalam-perbaikan", color: "text-amber-600" },
    { label: "Aset Rusak", value: stats?.rusak, icon: AlertTriangle, testid: "stat-rusak", color: "text-destructive" },
  ];

  return (
    <div data-testid="dashboard-page" className="space-y-8">
      <div>
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground">Sistem Informasi Pemeliharaan Aset Teknologi Informasi</p>
        <h1 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight mt-1" data-testid="dashboard-title">
          Dashboard <span className="text-primary">SIPAT</span>
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.testid} className="bg-card border border-border rounded-lg p-5 shadow-sm hover:-translate-y-[1px] transition-transform duration-200" data-testid={c.testid}>
            <div className="flex items-center justify-between">
              <p className="text-xs font-semibold tracking-[0.15em] uppercase text-muted-foreground">{c.label}</p>
              <c.icon className={`w-5 h-5 ${c.color}`} />
            </div>
            <p className="text-4xl font-heading font-semibold mt-3" data-testid={`${c.testid}-value`}>
              {stats ? c.value : "—"}
            </p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-card border border-border rounded-lg p-6 shadow-sm" data-testid="chart-ruangan-rusak">
          <h2 className="text-lg font-heading font-semibold">Ruangan Paling Sering Mengalami Kerusakan</h2>
          <p className="text-sm text-muted-foreground mb-4">Berdasarkan riwayat maintenance berstatus Rusak / Perbaikan</p>
          {stats && stats.ruangan_rusak.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={stats.ruangan_rusak} margin={{ top: 8, right: 16, left: -16, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(214 32% 91%)" />
                <XAxis dataKey="ruangan" tick={{ fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Bar dataKey="jumlah" name="Jumlah Kerusakan" fill="hsl(158 95% 30%)" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-sm text-muted-foreground py-16 text-center" data-testid="chart-empty">Belum ada data kerusakan.</p>
          )}
        </div>
        <div className="bg-card border border-border rounded-lg p-6 shadow-sm" data-testid="status-distribution">
          <h2 className="text-lg font-heading font-semibold flex items-center gap-2">
            <Activity className="w-4 h-4 text-primary" /> Distribusi Status Aset
          </h2>
          <div className="mt-4 space-y-3">
            {(stats?.distribusi_status || []).map((s) => (
              <div key={s.status} className="flex items-center justify-between border-b border-border pb-2 last:border-0">
                <span className="text-sm">{s.status}</span>
                <span className="text-sm font-semibold">{s.jumlah} unit</span>
              </div>
            ))}
            {stats && stats.distribusi_status.length === 0 && (
              <p className="text-sm text-muted-foreground">Belum ada aset.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
